import { render, staticRenderFns } from "./agentUpdate.vue?vue&type=template&id=0d64e88e&scoped=true&"
import script from "./agentUpdate.vue?vue&type=script&lang=js&"
export * from "./agentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64e88e",
  null
  
)

export default component.exports